// This file contains compile-time defined variables.

export const NAME: string = "1.8.0";

export const VERSION: string = "@shockpkg/core";
